// src/components/Parametres.js
import React, { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useTombola } from "../contexts/TombolaContext";
import { useOrg } from "../contexts/OrgContext";
import {
  saveParametres, ecouterParametres,
  archiverTombola, supprimerTombola,
} from "../services/db";
import { creerSessionPaiement } from "../services/stripe";
import { db } from "../services/firebase";
import { doc, updateDoc } from "firebase/firestore";

export default function Parametres() {
  const { orgId, currentUser } = useAuth();
  const { activeTombola, activeTombolaId, isPro } = useTombola();
  const { organisation } = useOrg();

  // Nouvelle tombola
  // Paramètres tombola active
  const [prixTicket, setPrixTicket] = useState("1");
  const [methodes, setMethodes] = useState(["Espèces", "Carte Bancaire", "Chèque"]);
  const [newMethode, setNewMethode] = useState("");
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);
  const [assoNom, setAssoNom] = useState("");
  const [savingAsso, setSavingAsso] = useState(false);
  const [loadingPaiement, setLoadingPaiement] = useState(false);
  const estAdminOrg = organisation?.adminId === currentUser?.uid;

  useEffect(() => { setAssoNom(organisation?.nom || ""); }, [organisation?.nom]);

  async function handleSaveAsso(e) {
    e.preventDefault();
    const nom = assoNom.trim().slice(0, 120);
    if (!nom || nom === organisation?.nom) return;
    setSavingAsso(true);
    try {
      await updateDoc(doc(db, "organisations", orgId), { nom });
      showMsg("✅ Nom de l'association enregistré.");
    } catch { showMsg("❌ Erreur.", "error"); }
    setSavingAsso(false);
  }

  async function handlePaiement() {
    if (!activeTombolaId) return;
    setLoadingPaiement(true);
    try {
      const { url } = await creerSessionPaiement({
        orgId, tombolaId: activeTombolaId, tombolaName: activeTombola?.nom || "Tombola",
      });
      window.location.href = url;
    } catch (e) {
      showMsg(`❌ ${e?.message || "Paiement indisponible. Réessayez."}`, "error");
      setLoadingPaiement(false);
    }
  }

  useEffect(() => {
    if (!orgId || !activeTombolaId) return;
    const unsub = ecouterParametres(orgId, activeTombolaId, (p) => {
      setPrixTicket(String(p.prixTicket || 1));
      setMethodes(p.methodesEncaissement || ["Espèces", "Carte Bancaire", "Chèque"]);
    });
    return unsub;
  }, [orgId, activeTombolaId]);

  function showMsg(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 3000);
  }

  async function handleSaveParams(e) {
    e.preventDefault();
    if (!activeTombolaId) return;
    setSaving(true);
    try {
      await saveParametres(orgId, activeTombolaId, {
        prixTicket: parseFloat(prixTicket) || 1,
        methodesEncaissement: methodes,
      });
      showMsg("✅ Paramètres enregistrés.");
    } catch { showMsg("❌ Erreur.", "error"); }
    setSaving(false);
  }

  async function handleArchiver() {
    if (!activeTombola) return;
    if (!window.confirm(`Archiver "${activeTombola.nom}" ?`)) return;
    try {
      await archiverTombola(orgId, activeTombolaId);
      showMsg("📦 Tombola archivée.");
    } catch { showMsg("❌ Erreur.", "error"); }
  }

  async function handleSupprimer() {
    if (!activeTombola) return;
    if (!window.confirm(`Supprimer définitivement "${activeTombola.nom}" ? Cette action est irréversible.`)) return;
    try {
      await supprimerTombola(orgId, activeTombolaId);
      showMsg("🗑️ Tombola supprimée.");
    } catch { showMsg("❌ Erreur.", "error"); }
  }

  function addMethode() {
    if (!newMethode.trim() || methodes.includes(newMethode.trim())) return;
    setMethodes([...methodes, newMethode.trim()]);
    setNewMethode("");
  }

  function removeMethode(m) {
    if (methodes.length <= 1) return;
    setMethodes(methodes.filter((x) => x !== m));
  }

  return (
    <div style={s.page}>
      <h2 style={s.title}>⚙️ Paramètres</h2>

      {msg && (
        <div style={{ ...s.msg, ...(msg.type === "error" ? s.msgErr : s.msgOk) }}>
          {msg.text}
        </div>
      )}

      {/* Association */}
      {estAdminOrg && (
        <div style={s.section}>
          <h3 style={s.sectionTitle}>🏢 Association</h3>
          <form onSubmit={handleSaveAsso} style={s.addMethodeRow}>
            <input type="text" value={assoNom} onChange={(e) => setAssoNom(e.target.value)}
              maxLength={120} placeholder="Nom de l'association ou du club"
              style={{ ...s.input, flex: 1, minWidth: "180px" }} />
            <button type="submit" disabled={savingAsso || !assoNom.trim() || assoNom.trim() === organisation?.nom}
              style={s.btnAdd}>{savingAsso ? "…" : "Enregistrer"}</button>
          </form>
          <p style={s.planLimit}>Ce nom apparaît sur la page de confirmation de vos acheteurs.</p>
        </div>
      )}

      {/* Plan de la tombola active */}
      {activeTombola && (
      <div style={s.planCard}>
        <div style={s.planLeft}>
          <div style={s.planName}>
            {isPro ? "⭐ Plan Pro" : "🆓 Plan Starter"}
          </div>
          <div style={s.planOrg}>{activeTombola.nom}</div>
          <div style={s.planLimit}>
            {isPro ? "Billets illimités, exports et rapport complet." : "Gratuit jusqu'à 100 billets pour cette tombola."}
          </div>
        </div>
        {!isPro && (
          <button style={s.btnUpgrade} onClick={handlePaiement} disabled={loadingPaiement}>
            {loadingPaiement ? "Redirection…" : "⭐ Passer en Pro, 29 €"}
          </button>
        )}
      </div>
      )}



      {/* Paramètres tombola active */}
      {activeTombola && (
        <div style={s.section}>
          <h3 style={s.sectionTitle}>
            Paramètres de "{activeTombola.nom}"
            {activeTombola.archived && <span style={s.archivedTag}> 📦 Archivée</span>}
          </h3>

          {!activeTombola.archived && (
            <form onSubmit={handleSaveParams}>
              {/* Prix ticket */}
              <div style={s.field}>
                <label style={s.label}>Prix du billet (€)</label>
                <input type="number" min="0" step="0.5"
                  value={prixTicket}
                  onChange={(e) => setPrixTicket(e.target.value)}
                  style={{ ...s.input, width:"120px" }} />
              </div>

              {/* Méthodes encaissement */}
              <div style={s.field}>
                <label style={s.label}>Méthodes d'encaissement</label>
                <div style={s.methodesList}>
                  {methodes.map((m) => (
                    <div key={m} style={s.methodeTag}>
                      <span>{m}</span>
                      <button type="button" onClick={() => removeMethode(m)} style={s.removeBtn}>×</button>
                    </div>
                  ))}
                </div>
                <div style={s.addMethodeRow}>
                  <input type="text" placeholder="Ajouter une méthode…"
                    value={newMethode}
                    onChange={(e) => setNewMethode(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addMethode())}
                    style={{ ...s.input, flex:1 }} />
                  <button type="button" onClick={addMethode} style={s.btnAdd}>+ Ajouter</button>
                </div>
              </div>

              <button type="submit" disabled={saving} style={s.btnSave}>
                {saving ? "Enregistrement…" : "💾 Enregistrer"}
              </button>
            </form>
          )}

          {/* Actions tombola */}
          <div style={s.dangerZone}>
            <div style={s.dangerTitle}>⚠️ Actions irréversibles</div>
            {!activeTombola.archived && (
              <button onClick={handleArchiver} style={s.btnArchive}>
                📦 Archiver cette tombola
              </button>
            )}
            <button onClick={handleSupprimer} style={s.btnDelete}>
              🗑️ Supprimer définitivement
            </button>
          </div>
        </div>
      )}


    </div>
  );
}

const s = {
  page: { maxWidth:"560px", margin:"0 auto" },
  title: { fontSize:"1.25rem", fontWeight:"700", color:"#1a1a2e", marginBottom:"1.25rem" },
  msg: { borderRadius:"10px", padding:"0.75rem 1rem", marginBottom:"1rem", fontSize:"0.9rem" },
  msgOk: { background:"#e8f5e9", color:"#1b5e20" },
  msgErr: { background:"#ffebee", color:"#b71c1c" },
  planCard: { display:"flex", alignItems:"center", justifyContent:"space-between", background:"linear-gradient(135deg,#f5f7ff,#faf5ff)", border:"1.5px solid #c7d2ff", borderRadius:"14px", padding:"1.1rem 1.25rem", marginBottom:"1.5rem", flexWrap:"wrap", gap:"10px" },
  planLeft: { display:"flex", flexDirection:"column", gap:"3px" },
  planName: { fontWeight:"800", color:"#1a1a2e", fontSize:"1rem" },
  planOrg: { fontSize:"0.82rem", color:"#667eea", fontWeight:"600" },
  planLimit: { fontSize:"0.78rem", color:"#888" },
  btnUpgrade: { padding:"0.6rem 1.1rem", background:"linear-gradient(135deg,#ffc107,#ff8f00)", color:"#fff", border:"none", borderRadius:"8px", fontWeight:"700", cursor:"pointer", fontSize:"0.85rem" },
  section: { background:"#f7f8fc", borderRadius:"12px", padding:"1.25rem", marginBottom:"1.25rem", border:"1px solid #eee" },
  sectionTitle: { fontSize:"0.95rem", fontWeight:"700", color:"#333", marginBottom:"1rem" },
  archivedTag: { color:"#888", fontWeight:"400", fontSize:"0.85rem" },
  createForm: { display:"flex", gap:"10px", flexWrap:"wrap", alignItems:"center" },
  field: { marginBottom:"1rem" },
  label: { display:"block", fontSize:"0.82rem", fontWeight:"600", color:"#555", marginBottom:"6px" },
  input: { padding:"0.6rem 0.9rem", border:"1.5px solid #e0e0e0", borderRadius:"8px", fontSize:"0.92rem", outline:"none", boxSizing:"border-box", background:"#fff" },
  methodesList: { display:"flex", flexWrap:"wrap", gap:"8px", marginBottom:"10px" },
  methodeTag: { display:"flex", alignItems:"center", gap:"6px", background:"#eef0ff", color:"#4c5ee8", borderRadius:"20px", padding:"4px 12px", fontSize:"0.85rem", fontWeight:"600" },
  removeBtn: { background:"none", border:"none", cursor:"pointer", color:"#764ba2", fontSize:"1rem", padding:"0", lineHeight:1 },
  addMethodeRow: { display:"flex", gap:"10px", flexWrap:"wrap" },
  btnAdd: { padding:"0.6rem 1rem", background:"#eef0ff", color:"#4c5ee8", border:"1px solid #c7d2ff", borderRadius:"8px", cursor:"pointer", fontWeight:"600", fontSize:"0.85rem" },
  btnCreate: { padding:"0.6rem 1.25rem", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"8px", fontWeight:"700", cursor:"pointer", fontSize:"0.88rem" },
  btnSave: { padding:"0.65rem 1.5rem", background:"linear-gradient(135deg,#667eea,#764ba2)", color:"#fff", border:"none", borderRadius:"8px", fontWeight:"700", cursor:"pointer", fontSize:"0.9rem" },
  dangerZone: { marginTop:"1.5rem", padding:"1rem", background:"#fafafa", border:"1px solid #e0e0e0", borderRadius:"10px" },
  dangerTitle: { fontSize:"0.78rem", fontWeight:"700", color:"#888", textTransform:"uppercase", letterSpacing:"0.5px", marginBottom:"0.75rem" },
  btnArchive: { display:"block", width:"100%", padding:"0.65rem", background:"#fff8e1", border:"1px solid #ffe082", borderRadius:"8px", color:"#e65100", fontWeight:"600", cursor:"pointer", fontSize:"0.88rem", marginBottom:"8px", textAlign:"center" },
  btnDelete: { display:"block", width:"100%", padding:"0.65rem", background:"#ffebee", border:"1px solid #ffcdd2", borderRadius:"8px", color:"#c62828", fontWeight:"600", cursor:"pointer", fontSize:"0.88rem", textAlign:"center" },
  tombolaRow: { display:"flex", justifyContent:"space-between", alignItems:"center", padding:"8px 0", borderBottom:"1px solid #eee" },
  tombolaName: { fontWeight:"600", color:"#333", fontSize:"0.9rem" },
  tombolaYear: { color:"#aaa", fontSize:"0.82rem" },
};
